function normalizeEmailList(raw: string | undefined): string[] {
  if (!raw) {
    return [];
  }

  return raw
    .split(",")
    .map((value) => value.trim().toLowerCase())
    .filter(Boolean);
}

export function isFeatureEnabledForEmail(
  email: string | null | undefined,
  allowedUsersRaw: string | undefined,
  fallbackAllowedUsersRaw?: string | undefined,
): boolean {
  if (import.meta.env.VITE_ENV === "DEV") {
    return true;
  }

  const normalizedEmail = (email || "").trim().toLowerCase();
  const allowedUsers = normalizeEmailList(allowedUsersRaw);
  const fallbackAllowedUsers = normalizeEmailList(fallbackAllowedUsersRaw);

  if (allowedUsers.includes("all")) {
    return true;
  }

  if (normalizedEmail && allowedUsers.includes(normalizedEmail)) {
    return true;
  }

  if (fallbackAllowedUsers.includes("all")) {
    return true;
  }

  return normalizedEmail ? fallbackAllowedUsers.includes(normalizedEmail) : false;
}
